import React from 'react';

const Icon = (props: { color?: string }) => {
    return (
        <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.90929 1.09859C9.78288 0.967136 9.58425 0.967136 9.45785 1.09859L5.50324 5.21127L1.53057 1.09859C1.40417 0.967136 1.20554 0.967136 1.07913 1.09859C0.970787 1.21127 0.970787 1.43662 1.09719 1.56808L5.26849 5.9061C5.32266 5.96244 5.41295 6 5.48518 6C5.55741 6 5.6477 5.96244 5.70187 5.9061L9.87317 1.56808C10.0357 1.43662 10.0357 1.21127 9.90929 1.09859Z"
                fill={props.color || '#757575'}
                stroke={props.color || '#757575'}
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
        </svg>
    );
};

export default Icon;
